import { render, staticRenderFns } from "./index.vue?vue&type=template&id=840cd13c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=840cd13c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_cache-loader@4.1.0_webpack@4.47.0__css-load_edeb7b7ea9fcdff8c5beb98344f810d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840cd13c",
  null
  
)

export default component.exports